import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import stateSelector from 'reduxModules/emailConfirmation/selectors'
import dispatchers from 'reduxModules/emailConfirmation/dispatchers'

import './styles.css'

export function VerifyBanner({ isMobile = false, displace = false, isResendCTADisabled = false, resendEmail = () => {} }) {
  return (
    <div id="VerifyBanner" className={classnames({ 'is-mobile-verify': isMobile, displace })}>
      <div className="wrapper-verify-banner">
        <span className="info">
          <b>Please verify your email to enjoy all the benefits of Stan Winston School of Character Arts.</b>
        </span>
        <button
          type="button"
          className={classnames('btn -thin -orange verify-button', { disabled: isResendCTADisabled })}
          disabled={isResendCTADisabled}
          onClick={() => resendEmail()}
          aria-label="Click this button to send the verification email again"
        >
          <span>Resend</span>
        </button>
      </div>
    </div>
  )
}

VerifyBanner.propTypes = {
  isMobile: PropTypes.bool,
  isResendCTADisabled: PropTypes.bool,
  displace: PropTypes.bool,
  resendEmail: PropTypes.func
}

export default connect(stateSelector, dispatchers)(VerifyBanner)
